import { getFireStoreSkpApiSettings } from './getGdeSkpApiSettings'
import { getCountries, getWorkerDetails, getGdeWorkerDetails, getWmsSystemFroCountry, getTemplateTypesForWms } from './gdeTransactions'
import { getUser } from '../../redux/global'

const garbageCollectRunTime = 60 * 60 * 1000
let intervalId

let consoleOn = false
if (process.env.NODE_ENV === 'production') {
  consoleOn = false
}
let cache = {}
export let userCountryCode

// 30 days
const maxMs = 30 * 24 * 60 * 60 * 1000

const makeKey = (doc, param) =>
  `${doc}\t${param}`

export const getUserCountryCode = () =>
  userCountryCode

export const getCache = (doc, param) => {
  const key = makeKey(doc, param)
  if (cache[key] === undefined) {
    if (consoleOn) {
      // eslint-disable-next-line no-console
      console.log('Cache miss 1', makeKey(doc, param), (new Date()).getTime())
    }
    return null
  }
  if ((new Date()).getTime() > cache[key].expires) {
    if (consoleOn) {
      // eslint-disable-next-line no-console
      console.log('Cache miss 2', makeKey(doc, param), (new Date()).getTime())
    }
    return null
  }
  if (consoleOn) {
    // eslint-disable-next-line no-console
    console.log('Cache hit', makeKey(doc, param), cache[key].data, (new Date()).getTime())
  }
  return cache[key].data
}

export const addCache = (doc, param, data, maxAgeInMs = maxMs) => {
  const key = makeKey(doc, param)
  const cacheEntry = {
    expires: (new Date()).getTime() + maxAgeInMs,
    data
  }
  cache[key] = cacheEntry
}

export const clearCache = () => {
  clearInterval(intervalId)
  cache = {}
}

const garbageCollect = () => {
  if (consoleOn) {
    // eslint-disable-next-line no-console
    console.log('Garbage collect start', (new Date()).getTime())
  }
  const currentTimeMs = (new Date()).getTime()
  const keys = Object.keys(cache)
  for (let i = 0; i < keys.length; ++i) {
    const key = keys[i]
    if (cache[key].expires <= currentTimeMs) {
      if (consoleOn) {
        // eslint-disable-next-line no-console
        console.log(`Garbage collect ${key}`, (new Date()).getTime())
      }
      delete cache[key]
    }
  }
  if (consoleOn) {
    // eslint-disable-next-line no-console
    console.log('Garbage collect end', (new Date()).getTime())
  }
}

export const loadApiCaches = async () => {
  getFireStoreSkpApiSettings()
  getCountries()
  getTemplateTypesForWms('')
  getTemplateTypesForWms('SKP')
  await getGdeWorkerDetails(getUser().workerId)
  const workerDetails = await getWorkerDetails(getUser().workerId)
  userCountryCode = workerDetails.countryCode
  getWmsSystemFroCountry(userCountryCode)

  intervalId = setInterval(garbageCollect, garbageCollectRunTime)
}